import SaveDocumentRequest from '@/modules/common/hiring/models/MID/requests/SaveDocumentRequest'
import type Insured from '@/modules/common/common/models/APP/Insured'
import CommonMapper from '@/modules/core/mappers/CommonMapper'

export default class SaveDocumentMapper {
  static async toRequest(quotationId: string, holder: Insured): Promise<SaveDocumentRequest> {
    return new SaveDocumentRequest({
      quotationId,
      document: [],
      policyHolder: {
        nacionality: holder.addressDetails.country,
        personType: holder.documentDetails.personType,
        documentType: holder.documentDetails.documentType,
        documentNumber: holder.documentDetails.documentNumber,
        documentExpirationDate: holder.documentDetails.documentExpirationDate
          ? CommonMapper.toMiddlewareDate(holder.documentDetails.documentExpirationDate)
          : undefined,
        privacyPolicyConsent: holder.privacyPolicyConsent,
        asisaNewsConsent: holder.asisaNewsConsent
      }
    })
  }
}
